import React from "react";
import { useLang } from "../context/LanguageContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

const TERMS = {
  es: {
    title: "Términos y Condiciones",
    intro:
      "Bienvenido a XPERIENCIAS MEXICO. Al reservar y utilizar nuestros servicios de transportación privada y experiencias/tours, aceptas los siguientes términos y condiciones.",
    sections: [
      {
        h: "1. Reservaciones",
        p: "Todas las reservaciones están sujetas a disponibilidad. Recomendamos reservar con al menos 24 horas de anticipación. Una vez confirmada tu reserva, recibirás los detalles por correo electrónico y/o WhatsApp.",
      },
      {
        h: "2. Precios y pagos",
        p: "Los precios mostrados están expresados en dólares estadounidenses (USD) y pueden variar según la temporada y disponibilidad. Las tarifas de traslados son por persona salvo que se indique lo contrario. El precio final se confirma al momento de reservar.",
      },
      {
        h: "3. Cancelaciones y reembolsos",
        p: "Las cancelaciones realizadas con más de 48 horas de anticipación tienen reembolso completo. Cancelaciones entre 24 y 48 horas tienen un cargo del 50%. Cancelaciones con menos de 24 horas o no presentarse (no-show) no son reembolsables.",
      },
      {
        h: "4. Servicio de traslados",
        p: "Monitoreamos los vuelos para ajustarnos a retrasos. El cliente debe proporcionar información correcta de vuelo, hotel y número de pasajeros. XPERIENCIAS MEXICO no se responsabiliza por retrasos causados por información incorrecta o fuerza mayor.",
      },
      {
        h: "5. Experiencias y tours",
        p: "Las experiencias y tours dependen de las condiciones climáticas y operativas de cada parque o destino. Los horarios y actividades pueden cambiar. Recomendamos llegar puntualmente al punto de encuentro.",
      },
      {
        h: "6. Responsabilidad",
        p: "XPERIENCIAS MEXICO actúa como intermediario para algunos servicios de terceros (parques, tours). No nos hacemos responsables por objetos perdidos, lesiones o daños ocasionados durante las actividades operadas por terceros.",
      },
      {
        h: "7. Privacidad",
        p: "Tus datos personales se utilizan únicamente para gestionar tu reserva y contacto. No compartimos tu información con terceros ajenos a la prestación del servicio.",
      },
      {
        h: "8. Contacto",
        p: "Para dudas sobre estos términos, escríbenos por WhatsApp o al correo hola@xperienciasmexico.com.",
      },
    ],
    updated: "Última actualización: julio 2025.",
  },
  en: {
    title: "Terms & Conditions",
    intro:
      "Welcome to XPERIENCIAS MEXICO. By booking and using our private transportation services and experiences/tours, you accept the following terms and conditions.",
    sections: [
      {
        h: "1. Reservations",
        p: "All reservations are subject to availability. We recommend booking at least 24 hours in advance. Once your booking is confirmed, you will receive the details by email and/or WhatsApp.",
      },
      {
        h: "2. Prices and payments",
        p: "Prices shown are in US dollars (USD) and may vary depending on season and availability. Transfer rates are per person unless otherwise stated. The final price is confirmed at the time of booking.",
      },
      {
        h: "3. Cancellations and refunds",
        p: "Cancellations made more than 48 hours in advance receive a full refund. Cancellations between 24 and 48 hours incur a 50% charge. Cancellations with less than 24 hours or no-shows are non-refundable.",
      },
      {
        h: "4. Transfer service",
        p: "We monitor flights to adjust for delays. The customer must provide correct flight, hotel and passenger information. XPERIENCIAS MEXICO is not responsible for delays caused by incorrect information or force majeure.",
      },
      {
        h: "5. Experiences and tours",
        p: "Experiences and tours depend on weather and operational conditions at each park or destination. Schedules and activities may change. We recommend arriving on time at the meeting point.",
      },
      {
        h: "6. Liability",
        p: "XPERIENCIAS MEXICO acts as an intermediary for some third-party services (parks, tours). We are not responsible for lost items, injuries or damages caused during activities operated by third parties.",
      },
      {
        h: "7. Privacy",
        p: "Your personal data is used solely to manage your booking and contact. We do not share your information with third parties unrelated to the service.",
      },
      {
        h: "8. Contact",
        p: "For questions about these terms, message us on WhatsApp or email hola@xperienciasmexico.com.",
      },
    ],
    updated: "Last updated: July 2025.",
  },
};

export default function TermsModal({ open, onOpenChange }) {
  const { lang } = useLang();
  const c = TERMS[lang];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{c.title}</DialogTitle>
          <DialogDescription>{c.intro}</DialogDescription>
        </DialogHeader>

        <ScrollAreaDiv>
          <div className="space-y-5">
            {c.sections.map((s) => (
              <div key={s.h}>
                <h4 className="font-display font-bold text-foreground">{s.h}</h4>
                <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{s.p}</p>
              </div>
            ))}
            <p className="text-xs text-muted-foreground pt-2 border-t border-border">{c.updated}</p>
          </div>
        </ScrollAreaDiv>
      </DialogContent>
    </Dialog>
  );
}

function ScrollAreaDiv({ children }) {
  return <div className="max-h-[60vh] overflow-y-auto pr-4">{children}</div>;
}
